import * as React from 'react';

import {LoadingText} from 'shells/loading-placeholder/loading-text';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {HeaderStatusButton} from '../shared-components/header-status-button/header-status-button';

import {useGetWhatsAppIntegration} from './graphql/hooks/use-get-whatsapp-integration';

export function WhatsAppHeaderButtons() {
    const {user} = useGetSessionUser();
    const {whatsAppIntegration, isLoading} = useGetWhatsAppIntegration();

    const userCanAccessSetup = Boolean(user && user.permissions.canAccessSetup);
    const isConnected = Boolean(whatsAppIntegration && whatsAppIntegration.hasAuthToken);
    const isEnabled = Boolean(whatsAppIntegration && whatsAppIntegration.isEnabled);

    if (!userCanAccessSetup) {
        return null;
    } else if (isLoading) {
        return <LoadingText height={31} width={200} />;
    }

    return (
        <HeaderStatusButton
            isConnected={isConnected}
            isEnabled={isEnabled}
            threadType='WHATSAPP'
            phoneNumber={whatsAppIntegration && whatsAppIntegration.userPhoneNumber}
        />
    );
}
